import { render, staticRenderFns } from "./OneServiceTotalOnly.vue?vue&type=template&id=216e5112&scoped=true&"
import script from "./OneServiceTotalOnly.vue?vue&type=script&lang=ts&"
export * from "./OneServiceTotalOnly.vue?vue&type=script&lang=ts&"
import style0 from "./OneServiceTotalOnly.vue?vue&type=style&index=0&id=216e5112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e5112",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
